export const PAY_TYPE_MAP = {
	WX: {
		name: '微信支付',
		id: 1,
		slug: 'WX',
	},
	WX_H5: {
		name: '微信支付',
		id: 2,
		slug: 'wx_h5',
	},
	WX_MINIPROGRAM: {
		name: '微信小程序支付',
		id: 11,
		slug: 'WX_MINIPROGRAM',
	},
	ALIPAY: {
		name: '支付宝支付',
		id: 6,
		slug: 'ALIPAY',
	},
	KUAI_QIAN_H5: {
		name: '快钱-微信',
		id: 13,
		slug: 'KUAI_QIAN',
	},
	KUAI_QIAN_WX: {
		name: '快钱-微信公众号',
		id: 14,
		slug: 'KUAI_QIAN',
	},
};